import Vue from 'vue'
import Router from 'vue-router'
import {store} from '@/vuex/store.js';
let _this = new Vue({
  store
});
Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: resolve => {
        require(['@/components/pc/pages/home/Home.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    {
      path: '/homeP',
      name: 'HomeP',
      redirect: '/',
      component: resolve => {
        require(['@/components/pc/pages/home/Home.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    { // 空白页
      path: '/nonePageP',
      name: 'NonePageP',
      component: resolve => {
        require(['@/components/pc/pages/none-page/NonePage.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    { // 栏目列表内容页
      path: '/columnContentListP',
      name: 'ColumnContentListP',
      component: resolve => {
        require(['@/components/pc/pages/column-contents/ColumnContentList.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    { // 文章详情
      path: '/articleDetailP',
      name: 'ArticleDetailP',
      component: resolve => {
        require(['@/components/pc/pages/details/Details.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    { // 搜索页面
      path: '/searchPageP',
      name: 'SearchPageP',
      component: resolve => {
        require(['@/components/pc/pages/search/SearchPage.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    { // 用户中心-主页
      path: '/userMainIndexP',
      name: 'UserMainIndexP',
      redirect: '/userNewDynamicP',
      component: resolve => {
        require(['@/components/pc/pages/user-manage-pages/user-main/UserMainIndex.vue'], resolve)
      },
      children: [
        { // 主页-最新动态
          path: '/userNewDynamicP',
          name: 'UserNewDynamicP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/user-main/new-dynamic/NewDynamic.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 个人中心-账号管理-账号信息
          path: '/userIdManageP',
          name: 'UserIdManageP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/personal-center/UserIdManage.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 个人中心-我的粉丝
          path: '/userMyFansP',
          name: 'UserMyFansP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/personal-center/MyFans.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 个人中心-我的关注
          path: '/userMyFocusP',
          name: 'UserMyFocusP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/personal-center/MyFocus.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 个人中心-我的收藏
          path: '/userMyCollectP',
          name: 'UserMyCollectP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/personal-center/MyCollect.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 个人中心-我的消息
          path: '/userMyMessageP',
          name: 'UserMyMessageP',
          redirect: '/userMyCommentP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/personal-center/my-message/MyMessage.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          },
          children: [
            { // 个人中心-我的消息-我的评论
              path: '/userMyCommentP',
              name: 'UserMyCommentP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/personal-center/my-message/MyComment.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            },
            { // 个人中心-我的消息-我的私信
              path: '/userMyPrivateLetterP',
              name: 'UserMyPrivateLetterP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/personal-center/my-message/MyPrivateLetter.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            },
            { // 个人中心-我的消息-系统通知
              path: '/userSystemNoticeP',
              name: 'UserSystemNoticeP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/personal-center/my-message/SystemNotice.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            },
          ]
        },
        { // 创作中心-投稿
          path: '/userContributeP',
          name: 'UserContributeP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/Contribute.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-授权申请
          path: '/userAccreditApplyP',
          name: 'UserAccreditApplyP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/accredit-apply/AccreditApply.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-授权申请-提交申请信息页
          path: '/userAccreditApplyFormP',
          name: 'UserAccreditApplyFormP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/accredit-apply/AccreditApplyForm.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-文章审核
          path: '/userArticleAuditP',
          name: 'UserArticleAuditP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/ArticleAudit.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-文章审核详情
          path: '/userArticleAuditDetailP',
          name: 'UserArticleAuditDetailP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/ArticleAuditDetail.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-公众号授权-容器
          path: '/userMpwxAccreditMainP',
          name: 'UserMpwxAccreditMainP',
          redirect: '/userMpwxAccreditP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/mpwx-accredit/MpwxAccreditMain.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          },
          children: [
            { // 创作中心-公众号授权
              path: '/userMpwxAccreditP',
              name: 'UserMpwxAccreditP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/creation-center/mpwx-accredit/MpwxAccredit.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            },
            { // 创作中心-公众号授权-大咖入驻
              path: '/userMasterApplyFormP',
              name: 'UserMasterApplyFormP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/creation-center/mpwx-accredit/MasterApplyForm.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            },
            { // 创作中心-公众号授权-企业入驻
              path: '/userConpanyApplyFormP',
              name: 'UserConpanyApplyFormP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/creation-center/mpwx-accredit/ConpanyApplyForm.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            },
            { // 创作中心-公众号授权-查看数据
              path: '/userCheckMpwxDataP',
              name: 'UserCheckMpwxDataP',
              component: resolve => {
                require(['@/components/pc/pages/user-manage-pages/creation-center/mpwx-accredit/CheckMpwxData.vue'], resolve)
              },
              meta: {
                isMobile: false,
                isLogin: true
              }
            }
          ]
        },
        { // 创作中心-伪原创
          path: '/userFalseOriginalP',
          name: 'UserFalseOriginalP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/FalseOriginal.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-内容管理
          path: '/userContentManageP',
          name: 'UserContentManageP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/ContentManage.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        },
        { // 创作中心-维权计划
          path: '/userSafeguardRightPlanP',
          name: 'UserSafeguardRightPlanP',
          component: resolve => {
            require(['@/components/pc/pages/user-manage-pages/creation-center/SafeguardRightPlan.vue'], resolve)
          },
          meta: {
            isMobile: false,
            isLogin: true
          }
        }
      ]
    },
    { // 用户中心-别人查看
      path: '/userOtherPeopleP',
      name: 'UserOtherPeopleP',
      component: resolve => {
        require(['@/components/pc/pages/user-manage-pages/user-main/OtherPeopleCenter.vue'], resolve)
      },
      meta: {
        isMobile: false,
        isLogin: false
      }
    },
    // 移动端
    { // 首页
      path: '/homeM',
      name: 'HomeM',
      component: resolve => {
        require(['@/components/mobile/pages/home/Home.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 文章详情页
      path: '/articleDetailM',
      name: 'ArticleDetailM',
      component: resolve => {
        require(['@/components/mobile/pages/details/ArticleDetail.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 文章详情页-回复评论列表
      path: '/replyCommentListM',
      name: 'ReplyCommentListM',
      component: resolve => {
        require(['@/components/mobile/pages/details/ReplyCommentList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 栏目列表内容页
      path: '/columnContentListM',
      name: 'ColumnContentListM',
      component: resolve => {
        require(['@/components/mobile/pages/column-contents/ColumnContentList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 转发推荐文章列表
      path: '/forwardArticleListM',
      name: 'ForwardArticleList',
      component: resolve => {
        require(['@/components/mobile/common/article-list/ForwardArticleList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 视频文章列表
      path: '/videoArticleList',
      name: 'VideoArticleList',
      component: resolve => {
        require(['@/components/mobile/common/article-list/VideoArticleList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 搜索页
      path: '/searchM',
      name: 'SearchM',
      component: resolve => {
        require(['@/components/mobile/pages/search/Search.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: false,
        headerHidden: false
      }
    },
    { // 小程序-商品列表-凤凰社
      path: '/goodsListM',
      name: 'GoodsListM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/GoodsList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 小程序-商品列表-卓悦汇
      path: '/zyhGoodsListM',
      name: 'ZyhGoodsListM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/ZyhGoodsList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 小程序-楼层导航列表-凤凰社
      path: '/levelListM',
      name: 'LevelListM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/LevelList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 小程序-楼层导航列表-卓悦汇
      path: '/zyhFloorListM',
      name: 'ZyhFloorListM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/ZyhFloorList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 小程序-到店巨惠-卓悦汇
      path: '/zyhStoreSalesM',
      name: 'ZyhStoreSalesM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/ZyhStoreSales.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 小程序-爆款促销-卓悦汇
      path: '/zyhHotPromotionM',
      name: 'ZyhHotPromotionM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/ZyhHotPromotion.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 小程序-新品-卓悦汇
      path: '/zyhNewGoodsM',
      name: 'ZyhNewGoodsM',
      component: resolve => {
        require(['@/components/mobile/pages/applets/ZyhNewGoods.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: true
      }
    },
    { // 公众号-“我的”页面主页-容器
      path: '/userMineMainIndexM',
      name: 'UserMineMainIndexM',
      component: resolve => {
        require(['@/components/mobile/pages/mine/MineMainIndex.vue'], resolve)
      },
      meta: {
        isMobile: true,
        isLogin: true,
        headerHidden: false
      },
      children: [
        { // 公众号-“我的”页面主页
          path: '/userMineIndexM',
          name: 'UserMineIndexM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/MineIndex.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-提现页
          path: '/userWithdrawM',
          name: 'UserWithdrawM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/withdraw/Withdraw.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-提现验证
          path: '/userWithdrawVerifyM',
          name: 'UserWithdrawVerifyM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/withdraw/WithdrawVerify.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-提现记录页
          path: '/userWithdrawRecordM',
          name: 'UserWithdrawRecordM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/withdraw/WithdrawRecord.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-提现记录-账单详情
          path: '/userBillDetailM',
          name: 'UserBillDetailM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/withdraw/BillDetail.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的关注
          path: '/userMineFollowM',
          name: 'UserMineFollowM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-follow/MineFollow.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的关注-设置
          path: '/userMineFollowSetM',
          name: 'UserMineFollowSetM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-follow/MineFollowSet.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的关注-公众号文章列表
          path: '/userMpwxArticlesM',
          name: 'UserMpwxArticlesM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-follow/MpwxArticles.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的关注-24小时栏目列表
          path: '/userMineFollowColumn',
          name: 'UserMineFollowColumnM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-follow/MineFollowColumn.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的转发
          path: '/userMineTranspondM',
          name: 'UserMineTranspondM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-transpond/MineTranspond.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的转发-一二级转发列表
          path: '/userTranspondListM',
          name: 'UserTranspondListM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-transpond/TranspondList.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的转发-用户的转发列表
          path: '/userPeopleTranspondListM',
          name: 'UserPeopleTranspondListM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-transpond/PeopleTranspondList.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-成交金额
          path: '/userBargainMoneyM',
          name: 'UserBargainMoneyM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/bargain-money/BargainMoney.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-成交金额-一二级成交
          path: '/userBargainRecordM',
          name: 'UserBargainRecordM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/bargain-money/BargainRecord.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的佣金
          path: '/userMineBrokerageM',
          name: 'UserMineBrokerageM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-brokerage/MineBrokerage.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的佣金-一二级佣金列表
          path: '/userBrokerageListM',
          name: 'UserBrokerageListM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-brokerage/BrokerageList.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的粉丝
          path: '/userMineFansM',
          name: 'UserMineFansM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-fans/MineFans.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的收藏
          path: '/userMineCollectionM',
          name: 'UserMineCollectionM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-collection/MineCollection.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的收藏-收藏文章列表
          path: '/userCollectionArticleListM',
          name: 'UserCollectionArticleListM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-collection/CollectionArticleList.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的消息
          path: '/userMineMessageM',
          name: 'UserMineMessageM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-message/MineMessage.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的消息-回复消息
          path: '/userMessageReplyM',
          name: 'UserMessageReplyM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-message/MessageReply.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
        { // 公众号-“我的”页面-我的消息-聊天记录
          path: '/userMessageRecordM',
          name: 'UserMessageRecordM',
          component: resolve => {
            require(['@/components/mobile/pages/mine/mine-message/MessageRecord.vue'], resolve)
          },
          meta: {
            isMobile: true,
            isLogin: true,
            headerHidden: false
          }
        },
      ]
    },
  ]
});
router.beforeEach((to, form, next) => {
  let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // iso终端判断
      isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent); // pc/移动终端判断
  _this.$store.commit('setEquipmentInfo', {isiOS: isiOS, isMobile: isMobile}); // 保存设备信息
  window.sessionStorage.setItem('setEquipmentInfo', JSON.stringify({isiOS: isiOS, isMobile: isMobile}));
  if(isMobile) { _this.$store.commit('goods', to.meta.headerHidden); }
  let toPageData = to.fullPath.split('?')[1]; // 去的页面所携带的参数
  if(to.path === '/nonePageP') { return next(); } // 去空白页，表示用户正在登录
  let token = window.localStorage.getItem('token') ? window.localStorage.getItem('token') : '';
  if(!to.meta.isMobile) { // 去pc端路径，判断当前设备
    if(isMobile) { // 在移动端想去pc端，判断去的页面是否需要登录
      if(to.path == '/') { return next({ path: '/homeM' }); }
      let toPath = to.path.substring(0, to.path.length - 1), 
          path = toPageData ? `${toPath}M?${toPageData}` : `${toPath}M`; // 去的页面路径
      if(to.meta.isLogin) { // 需要登录，判断是否登录
        if(token) { return next({ path: path }); } // 已登录，通过
        var ua = navigator.userAgent.toLowerCase();
        let iswx = ua.indexOf('micromessenger') != -1;
        window.sessionStorage.setItem('isweixin', JSON.stringify({iswx: iswx}));
        if(iswx) {
          // 如果在微信端，调起微信登录授权页
          let targeturl = 'homeM';
          if(to.fullPath && String(to.fullPath).length > 1) {
            targeturl = String(to.fullPath).substr(1);
          }
          window.location.href = `https://api.bigbays.cn/api/user/userinfo?type=3&targeturl=${targeturl}`;
          return;
        }
        return next({path: form.fullPath}); // 没有登录，返回来的页面
      }
      return next({ path: path }); // 不需要登录，通过
    } else { // 在pc端去pc端，判断去的页面是否需要登录
      let tofullpath = to.fullPath == 'homeP' ? '/' : to.fullPath;
      window.sessionStorage.setItem('currentPageName', JSON.stringify({path: tofullpath})); // 保存当前页，登录时用
      if(to.meta.isLogin) { // 需要登录，判断是否登录
        if(token) { return next(); } // 已登录，通过
        return next({path: form.fullPath}); // 没有登录，返回来的页面
      }
      return next(); // 不需要登录，通过
    }
  } else { // 去移动端路径，判断当前设备
    if(isMobile) { // 在移动端去移动端，判断去的页面是否需要登录
      if(to.meta.isLogin) { // 需要登录，判断是否登录
        if(token) { return next(); } // 已登录，通过
        var ua = navigator.userAgent.toLowerCase();
        let iswx = ua.indexOf('micromessenger') != -1;
        window.sessionStorage.setItem('isweixin', JSON.stringify({iswx: iswx}));
        if(iswx) {
          // 如果在微信端，调起微信登录授权页
          let targeturl = 'homeM';
          if(to.fullPath && String(to.fullPath).length > 1) {
            targeturl = String(to.fullPath).substr(1);
          }
          window.location.href = `https://api.bigbays.cn/api/user/userinfo?type=3&targeturl=${targeturl}`;
          return;
        }
        return next({path: form.fullPath}); // 没有登录，返回来的页面
      }
      return next(); // 不需要登录，通过
    } else { // 在pc端想去移动端，判断去的页面是否需要登录
      let toPath = to.path.substring(0, to.path.length - 1), 
          path = toPageData ? `${toPath}P?${toPageData}` : `${toPath}P`;
      window.sessionStorage.setItem('currentPageName', JSON.stringify({path: path})); // 保存当前页，登录时用
      if(to.meta.isLogin) { // 需要登录，判断是否登录
        if(token) { return next({ path: path }); } // 已登录，通过
        return next({path: form.fullPath}); // 没有登录，返回来的页面
      }
      return next({ path: path }); // 不需要登录，通过
    }
  }
});

export default router




// WEBPACK FOOTER //
// ./src/router/index.js